import {
  createRequestOptions,
  getAuthHeaders,
  handleApiResponse,
} from "../../../api/utils/apiHelpers";
import { API_ENDPOINTS } from "../../../enums/apiUrls";
import { logDataToConsole, logError } from "../../../utils/customLogger";
import { SftpPushTrailRow } from "../types/sftpPushTrail";
import {
  buildPushTrailRequestBody,
  PushTrailRequestParams,
} from "./buildPushTrailRequestBody";

export type FetchPushTrailParams = PushTrailRequestParams;

/**
 * Fetches the recorded SFTP push history for a single case.
 *
 * Reads the append-only `sftp_push_trail` table through the shared BigQuery
 * endpoint, which enforces `org_id` scoping server-side.
 *
 * @input params - Org and business-key identifiers for the case
 * @return SftpPushTrailRow[]: Pushes for the case, oldest first
 */
export const fetchNycbsExternalPushTrail = async (
  params: FetchPushTrailParams,
): Promise<SftpPushTrailRow[]> => {
  const body = buildPushTrailRequestBody(params);

  // Unkeyable case: querying anyway would return the whole input file.
  if (!body) {
    return [];
  }

  try {
    const headers = await getAuthHeaders();
    const response = await fetch(
      API_ENDPOINTS.GET_PHARMA_STP_FILE_DATA,
      createRequestOptions(body, headers),
    );
    const result = await handleApiResponse(response);

    logDataToConsole("fetchNycbsExternalPushTrail", result);
    return Array.isArray(result?.rows)
      ? (result.rows as SftpPushTrailRow[])
      : [];
  } catch (error) {
    logError(error as Error, "Error in fetchNycbsExternalPushTrail");
    throw error;
  }
};
